import { createContext } from "react";
import { PartialFlowStep } from ".";

// Steps of the flow being edited, for conditions that link to another step.
// Absent outside branch-step inspectors (e.g. trigger skip-conditions UI).
export const FlowStepsContext = createContext<PartialFlowStep[] | undefined>(
  undefined,
);
